/*
 * Quick-filter hero — collection-jump.
 * Plain initializer (no customized built-in element) so it works in ALL browsers,
 * including Safari/iOS which does not support extends:'form'. Targets the existing
 * form[is="quick-filter-hero"] attribute (kept in the DOM even when unsupported)
 * plus an optional [data-quick-filter-hero] hook.
 */
(function () {
  function getSelectedUrl(select) {
    var option = select.options[select.selectedIndex];
    var url = option ? option.dataset.url : '';
    return url && url.trim() !== '' ? url : null;
  }

  function init(form) {
    if (form.dataset.qfhBound === 'true') return;
    var select = form.querySelector('[data-quick-filter-hero-select]');
    var submitButton = form.querySelector('[data-quick-filter-hero-submit]');
    if (!select) return;
    form.dataset.qfhBound = 'true';

    function reflect() {
      if (!submitButton) return;
      if (getSelectedUrl(select)) {
        submitButton.removeAttribute('disabled');
      } else {
        submitButton.setAttribute('disabled', 'disabled');
      }
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var url = getSelectedUrl(select);
      if (url) window.location.assign(url);
    });
    select.addEventListener('change', reflect);
    reflect();
  }

  function initAll(root) {
    var scope = root || document;
    var forms = scope.querySelectorAll('form[is="quick-filter-hero"], [data-quick-filter-hero]');
    for (var i = 0; i < forms.length; i++) init(forms[i]);
  }

  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  }

  // Re-init after a Shopify section re-render (theme editor).
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
